export default "__VITE_ASSET__CTDge5Ws__"